import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "i18n"

// Material UI
import { makeStyles } from "@material-ui/core/styles"
import { Grid, Typography } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
  imageContainer: {
    width: 128,
    justifyContent: "center",
    margin: theme.spacing(1, 1.5)
  },
  img: {
    margin: "auto",
    display: "block",
    maxWidth: "100%",
    maxHeight: "100%"
  },
  imageSection: {
    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(4)
    }
  }
}))

export default function AboutItem({ description, images, type }) {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <Grid container direction="column" spacing={3}>
      <Grid item>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <Typography variant="h6" className="text-bold">
              {t("About this")} {t(type)}
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              variant="body1"
              dangerouslySetInnerHTML={{ __html: description }}
            ></Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item container>
        {images.awarded_by.length > 0 && (
          <Grid item xs={12} md={4}>
            <Grid container direction="column" spacing={1}>
              <Grid item>
                <Typography variant="h6">Awarded By</Typography>
              </Grid>
              <Grid item container alignItems="center">
                {images.awarded_by.map(body => (
                  <Grid item key={body.name} className={classes.imageContainer}>
                    <img
                      className={classes.img}
                      src={body.image}
                      alt={body.name}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        )}
        {images.approved_by.length > 0 && (
          <Grid item xs={12} md={4}>
            <Grid
              container
              direction="column"
              spacing={1}
              className={classes.imageSection}
            >
              <Grid item>
                <Typography variant="h6">Approved By</Typography>
              </Grid>
              <Grid item container alignItems="center">
                {images.approved_by.map(body => (
                  <Grid item key={body.name} className={classes.imageContainer}>
                    <img
                      className={classes.img}
                      src={body.image}
                      alt={body.name}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        )}
        {images.accredited_by.length > 0 && (
          <Grid item xs={12} md={4}>
            <Grid
              container
              direction="column"
              spacing={1}
              className={classes.imageSection}
            >
              <Grid item>
                <Typography variant="h6">Accredited By</Typography>
              </Grid>
              <Grid item container alignItems="center">
                {images.accredited_by.map(body => (
                  <Grid item key={body.name} className={classes.imageContainer}>
                    <img
                      className={classes.img}
                      src={body.image}
                      alt={body.name}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
    </Grid>
  )
}

AboutItem.propTypes = {
  description: PropTypes.string.isRequired,
  images: PropTypes.shape({
    awarded_by: PropTypes.array,
    approved_by: PropTypes.array,
    accredited_by: PropTypes.array
  }),
  type: PropTypes.oneOf(["course", "package", "certification", "qualification"])
}

AboutItem.defaultProps = {
  type: "course",
  description: "",
  images: {
    awarded_by: [],
    approved_by: [],
    accredited_by: []
  }
}
